export default __webpack_public_path__ + "img/eIixqnWU.f1a7d24a.svg";